<div class="page-content">
	@if (warning) {
		<div class="pseudo-page mx-3">
			<p>An error has occurred please try again later!</p>
		</div>
	} @else {
		<!--{{"redirect" | translate:systemLanguage}}-->
	}
</div>
